import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';

@Directive({
  selector: '[appCustomUsercodeValidation]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: CustomUsercodeValidationDirective,
    multi: true
  }]
})
export class CustomUsercodeValidationDirective implements Validator {

  @Input('appCustomUsercodeValidation') codeArr: string[];

  validate(control: AbstractControl): { [key: string]: any } | null {
    return control.dirty && this.codeArr?.includes(control?.value?.toString()) ? {'userCodeExist': true} : null;
  }

  registerOnValidatorChange?(fn: () => void): void {

  }
}
